import axios from "@/api/axiosInstance";
import type { ListCompanyEventRegistrationsResponse } from "./types";

export const listCompanyEventRegistrations =
  async (): Promise<ListCompanyEventRegistrationsResponse> => {
    const response = await axios.get<ListCompanyEventRegistrationsResponse>(
      "/api/private/company/event-registrations",
    );
    return response.data;
  };
